const CONTACT_EMAIL = "tanisha@raintherapeutics.co";

export function makePolicyEmailClickable(html = "") {
  if (!html || typeof document === "undefined") return html;

  const container = document.createElement("div");
  container.innerHTML = html;

  container.querySelectorAll("a").forEach((link) => {
    if (link.textContent.trim().toLowerCase() === CONTACT_EMAIL) {
      link.setAttribute("href", `mailto:${CONTACT_EMAIL}`);
    }
  });

  const walker = document.createTreeWalker(
    container,
    NodeFilter.SHOW_TEXT,
    null,
    false
  );
  const textNodes = [];

  while (walker.nextNode()) {
    const node = walker.currentNode;
    const parentTag = node.parentElement?.tagName;

    if (!["A", "SCRIPT", "STYLE"].includes(parentTag)) {
      textNodes.push(node);
    }
  }

  textNodes.forEach((node) => {
    const text = node.nodeValue;
    const emailPattern = /tanisha@raintherapeutics\.co/gi;

    if (!emailPattern.test(text)) return;

    const fragment = document.createDocumentFragment();
    let lastIndex = 0;

    text.replace(emailPattern, (match, offset) => {
      fragment.appendChild(document.createTextNode(text.slice(lastIndex, offset)));

      const link = document.createElement("a");
      link.href = `mailto:${CONTACT_EMAIL}`;
      link.textContent = match;
      fragment.appendChild(link);

      lastIndex = offset + match.length;
      return match;
    });

    fragment.appendChild(document.createTextNode(text.slice(lastIndex)));
    node.replaceWith(fragment);
  });

  return container.innerHTML;
}
